'use client';

import { ReactElement, useEffect, useMemo } from 'react';

import s from './Loading.module.css';

type LoadingProps = {
  variant?: 'fullscreen' | 'element';
};

const Loading = ({ variant = 'fullscreen' }: LoadingProps): ReactElement => {
  useEffect(() => {
    if (variant === 'fullscreen') {
      document.documentElement.style.overflow = 'hidden';
    }
    return () => {
      if (variant === 'fullscreen') {
        document.documentElement.style.overflow = 'auto';
      }
    };
  }, [variant]);

  const loadingIcon = useMemo(
    () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="81"
        viewBox="0 0 80 81"
        fill="none"
        className={s.mainShape}
      >
        <path
          d="M38.7764 0.499999C42.2406 0.513381 45.1642 0.856788 47.867 2.2215C54.4215 5.53515 57.0207 13.3666 53.7503 19.9895C51.5519 24.4449 49.277 28.869 47.0517 33.311C44.6777 38.0429 44.6822 42.7793 47.0607 47.5112C49.0788 51.5295 51.151 55.5299 53.1196 59.575C57.2415 68.0398 52.5835 77.8202 43.3938 80.0724C34.159 82.338 25.2216 75.3093 25.3117 65.8545C25.3342 63.5844 25.8657 61.4482 26.8883 59.4234C28.8659 55.5121 30.8345 51.5964 32.8121 47.6806C35.2582 42.8372 35.2627 37.9939 32.8256 33.1505C30.6453 28.8155 28.4335 24.4984 26.2757 20.1545C22.3655 12.2829 26.7757 3.00642 35.3933 0.990577C36.6502 0.696228 37.9611 0.615959 38.7809 0.499999L38.7764 0.499999Z"
          fill="#5A33FE"
        />
        <path
          className={s.shape1}
          d="M20.5574 19.4561C24.4007 19.6023 27.421 21.2951 29.2537 24.8269C31.0775 28.341 32.8257 31.8994 34.5649 35.4534C36.2063 38.8079 36.2241 42.2024 34.5916 45.5614C32.8924 49.0533 31.1576 52.5275 29.3961 55.9884C27.6212 59.4671 24.7432 61.3947 20.8376 61.5365C16.8253 61.6783 13.7249 59.9146 11.7899 56.4138C5.95825 45.8405 5.9716 35.2141 11.7721 24.6364C13.627 21.2552 16.6029 19.5802 20.5574 19.4605L20.5574 19.4561Z"
          fill="#5A33FE"
        />
        <path
          className={s.shape2}
          d="M72.903 40.5281C72.7817 46.3933 71.3342 51.8956 68.1786 56.8887C64.8657 62.1298 57.6734 63.1169 53.0253 58.9737C52.1982 58.2344 51.47 57.3004 50.9531 56.3221C49.0111 52.6437 47.1232 48.9298 45.3161 45.1849C43.8911 42.2324 43.7967 39.1382 45.1812 36.1635C47.0198 32.2195 48.9302 28.2975 51.0295 24.4863C54.6975 17.8243 64.3937 17.78 68.3539 24.349C71.0375 28.7933 72.5164 33.6138 72.8041 38.7841C72.8356 39.364 72.8716 39.9438 72.903 40.5281Z"
          fill="#5A33FE"
        />
      </svg>
    ),
    [],
  );

  if (variant === 'fullscreen') return <section className={s.fullscreen}>{loadingIcon}</section>;

  return <span>{loadingIcon}</span>;
};

export default Loading;
